var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20,1c10.49,0,19,8.51,19,19s-8.51,19-19,19S1,30.49,1,20,9.51,1,20,1m0-1C8.95,0,0,8.95,0,20s8.95,20,20,20,20-8.95,20-20S31.05,0,20,0Z",
    fill: "#eaeaea",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.04,27.64c0-1.63,1.37-3,3-3v-2.5c0-1.43,1.07-2.5,2.5-2.5s2.5,1.07,2.5,2.5v1.81l2.01.3c.73.1,1.42.47,2.01,1.02,0,0,0,0,0-.01v-11.34c0-.55-.45-1-1-1h-10.54l-3.23-3.23h-8.35c-.55,0-1,.45-1,1v14.57c0,1.66,1.34,3,3,3h9.1v-.62Z",
    fill: "#444",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.54,26.94c-.4-.6-1-1.1-1.7-1.2l-3.3-.5v-3.1c0-.6-.4-1-1-1s-1,.4-1,1v6.5c0,.3-.2.5-.5.5s-.5-.2-.5-.5v-2.5h-.5c-.8,0-1.5.7-1.5,1.5v2c.1,1.5,1,2.8,2.3,3.4,0,.1.1.1.2.1h6c.2,0,.4-.1.5-.3l1.3-3.8c.2-.7.1-1.5-.3-2.1Z",
    fill: "#ef5323",
    strokeWidth: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.07e0fd453aed203f1617e2b1b8565dd9.svg";
export { ForwardRef as ReactComponent };